<template>
  <div>
    <h5>
      {{
        "check_limit_buyer" | setText("Проверить лимит пользователя в системе")
      }}
      {{ order.client.phone }}
      {{ partner.name }}
    </h5>
    <div v-if="should_rescore && !rescoring_in_process">
      <h4>
        {{
          "intend_notify_1" | setText("Внимание!!! Нужно перескорить клиента")
        }}
      </h4>
      <button @click="rescoring" class="btn btn-info mt-2">
        {{ "peresc" | setText("Перескорить") }}
      </button>
    </div>
    <div v-else-if="should_rescore && rescoring_in_process">
      <h5>
        {{
          "wait_perescoring"
            | setText(
              'Ожидайте, клиент на перескоринге. Попробуйте нажать "Далее" через 2 минуты'
            )
        }}
      </h5>
    </div>
    <div class="install-control">
      <button @click="next" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  props: {
    partner: {
      default: function () {
        return {};
      },
    },
    order: {
      default: function () {
        return {};
      },
    },
    hash: {
      default: null,
    },
    index: {
      default: 0,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    next() {
      this.save();
    },
    rescoring() {
      this.$loading(true);

      logger(this.$http, {
        name: "Запрос на перескоринг в #INTEND",
        description: "",
        model_type: "order",
        model_id: this.order.id,
      });
      this.$http({
        url: `${this.partner["endpoint_url"]}member/rescore`,
        method: "GET",
        headers: {
          "api-key": `${this.partner["api_public_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${this.hash}`,
        },
      })
        .then((response) => {
          if (response.data.success) {
            this.rescoring_in_process = true;
            this.message = "Отправлен запрос на перескоринг #intend";
          } else if (response.data.error) {
            this.message = response.data.error["message"];
          } else {
            this.message = "Неизвестная ошибка";
          }
          logger(this.$http, {
            name: "Перескоринг #INTEND",
            description: this.message,
            model_type: "order",
            model_id: this.order.id,
          });
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Ошибка перескоринга #INTEND",
            description: "Ошибка в системе #INTEND",
            model_type: "order",
            model_id: this.order.id,
          });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    save() {
      this.$loading(true);

      logger(this.$http, {
        name: "Проверка лимита пользователя в #INTEND",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });

      this.$http({
        url: `${this.partner["endpoint_url"]}member/limits`,
        method: "GET",
        headers: {
          "api-key": `${this.partner["api_public_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${this.hash}`,
        },
      })
        .then((response) => {
          if (response.data.data) {
            this.message = "Получен успешно результат лимита";

            //NEED VARIABLE
            this.should_rescore = response.data.data.should_rescore;
            this.rescoring_in_process = response.data.data.rescoring_in_process;

            if (this.should_rescore || this.rescoring_in_process) {
              this.message =
                "Клиента необходимо перескорить или клиент на перескоринге";
            } else {
              this.$emit("getBuyer", response.data.data.limit);
              this.$emit("next", 4);
            }
          } else if (response.data.error) {
            this.message = response.data.error["message"];
          } else {
            this.message = "Ошибка сервера - лимит не получен";
          }
          if (this.message) {
            this.$notify({
              title: this.partner.name,
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Проверка лимита пользователя в #INTEND",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Проверка лимита пользователя в #INTEND",
            description: "Ошибка в системе #INTEND",
            model_type: "order",
            model_id: this.order.id,
          });
          alert("Ошибка партнера");
        })
        .finally(() => {
          // this.$emit('next', 4);//test
          // this.$emit('getBuyer', 4000);//test
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
      should_rescore: false,
      rescoring_in_process: false,
    };
  },
};
</script>
<style lang="scss">
</style>
